import { IdentificationDocument } from "../../features/registration/registration.models";
import { AsylumDTO, PassDTO, SaDTO } from "../models/dto.models";

export const getIdentificationDetail = (
  indentification: IdentificationDocument
): SaDTO | PassDTO | AsylumDTO => {
  switch (indentification.type) {
    case "I": {
      return {
        idNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as SaDTO;
    }
    case "P": {
      return {
        passportNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as PassDTO;
    }

    case "A": {
      return {
        asylumNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as AsylumDTO;
    }

    default:
      return {} as SaDTO;
  }
};
